// Only the public service origin belongs in the browser. Provider keys and OAuth
// client secrets stay on the server. An unset origin disables connection actions.
const configuredOrigin = (process.env.REACT_APP_TALENT_CONNECTOR_ORIGIN || '').trim().replace(/\/$/, '');
export const connectorOrigin = (() => {
  if (!configuredOrigin) return '';
  try {
    const url = new URL(configuredOrigin);
    const local = process.env.NODE_ENV !== 'production' && ['localhost', '127.0.0.1'].includes(url.hostname);
    return (url.protocol === 'https:' || (local && url.protocol === 'http:')) &&
      !url.username && !url.password && url.pathname === '/' && !url.search && !url.hash ? url.origin : '';
  } catch { return ''; }
})();

export async function connectorRequest(user, path, { body, signal } = {}) {
  if (!connectorOrigin) throw Object.assign(new Error('Connector is not configured'), { code: 'not_configured' });
  if (!user) throw Object.assign(new Error('Sign in first'), { code: 'unauthorized' });
  const token = await user.getIdToken();
  const response = await fetch(`${connectorOrigin}/platform/${path}`, {
    method: body ? 'POST' : 'GET', signal, cache: 'no-store', credentials: 'omit',
    headers: { Authorization: `Bearer ${token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw Object.assign(new Error('Connector request failed'), {
    code: data.code || (response.status === 401 ? 'unauthorized' : response.status === 403 ? 'access_required' : 'unavailable'),
  });
  return data;
}
